export enum CustomColorScheme {
  Green = "green",
  Red = "red",
  Blue = "blue",
}
